const str = `{HEADER}AI Terms of Service

{BODY_TITLE}Article 1: Purpose
These terms apply to AI-based features and outputs provided within the VideoMonster service and are in addition to the existing Terms of Service and Copyright Policy. Users are responsible for reviewing and complying with these terms and the restriction policies in the Terms of Service before using the AI services provided by VideoMonster. These terms may be updated by the company from time to time.

{BODY_TITLE}Article 2: Definitions
The definitions of terms used in these terms are as follows:
1) AI Features: Refers to all AI-based features provided by VideoMonster, including text, image, and video functions.
2) AI Outputs: Refers to text, images, and videos provided and processed through AI features within the VideoMonster service.
3) Technology Partners: Refers to third-party service providers that VideoMonster uses to provide AI features.

{BODY_TITLE}Article 3: Restrictions on Use
In addition to the prohibitions in the Terms of Service, the following uses of AI outputs are prohibited:
1) AI outputs cannot be used in a way that deceives or misleads others into believing they were created by humans.
2) AI outputs cannot be presented as if they were created by the user themselves.
3) AI outputs cannot be used if they are obscene or pornographic and violate public morals.
4) AI outputs cannot be used if they violate or infringe upon the rights of others (including personal information, portrait rights, publicity rights, etc.) or defame or insult others.
5) AI outputs cannot be used if they could be misinterpreted as medical results.
6) AI outputs cannot be sold.

{BODY_TITLE}Article 4: User Rights and Obligations
1) Users are responsible for the content they input to use AI features, and neither the company nor the users can claim copyright over AI outputs.
2) Users are legally responsible for any consequences arising from using AI outputs in violation of these terms.
3) Users cannot use AI outputs to develop machine learning models or related technologies.
4) When users share and post AI outputs, it is recommended that they clearly indicate that the outputs were generated by AI.

{BODY_TITLE}Article 5: Company Rights and Obligations
1) The company is not responsible for any disputes or damages that occur when users use generated AI outputs.
2) The generated AI outputs provided by the company are created by artificial intelligence, and the company does not provide any warranty or guarantee regarding the accuracy, reliability, or representativeness of the generated AI outputs.
3) The company does not claim copyright over the text entered by users or the outputs generated by users.
4) The company may use users' generated AI outputs to improve services or for marketing and promotional purposes.

{BODY_TITLE}Article 6: Technology Partners
1) The company uses technology models provided by third-party service providers to provide generative AI-based services.
2) Some of the data input by users for AI feature use may be shared with third-party service providers, and these third-party providers may use such data to improve their own services.
3) Data shared with third-party service providers may include users' personal information, and users agree that the company's privacy policy applies to the processing of this personal information.
4) According to the policies of third-party service providers, the level of personal information protection may not be the same depending on the country where the user resides.
- Third-party Service Provider : Open AI, LLC
- Shared Data : Text entered by the user

- Third-party Service Provider : Stability AI
- Shared Data : Images and text entered by the user

{FOOTER_SUB}Announcement date: October 18, 2024
{FOOTER_SUB_2}Effective date: November 1, 2024
`

export default str